module.exports = __webpack_public_path__ + "static/media/scrum8.4aa642b1.png";